import cx from 'classnames';
import { PrimaryButton } from '@/common/Button';
import {
  PromoCard,
  Copy,
  Image,
  InnerWrapper,
  Title
} from './StaticPromoTile.styles';
import {
  TileType,
  getTileBtnInfo,
  getTileCopy,
  getTileImgSrc,
  getTileTitle
} from '../TileUtils';

type OwnProps = {
  type: TileType;
};

export default function StaticPromoTile({ type }: OwnProps) {
  const tileTitle = getTileTitle(type);
  const tileCopy = getTileCopy(type);
  const { btnText, btnLink } = getTileBtnInfo(type);
  const imageUrl = getTileImgSrc(type);

  const isTackerOrInsurance =
    type === TileType.Insurance || type === TileType.Value;

  return (
    <PromoCard data-qa={`${type} promo tile`}>
      {imageUrl && <Image src={imageUrl} alt={`${type} promo tile`} />}
      <InnerWrapper>
        <Title
          className={cx(
            { 'tl-header-s m:tl-header-m': isTackerOrInsurance },
            { 'tl-header-m m:tl-header-xl': !isTackerOrInsurance }
          )}
        >
          {tileTitle}
        </Title>
        <Copy className={isTackerOrInsurance ? 'm:max-w-[360px]' : ''}>
          {tileCopy}
        </Copy>
        <a
          href={btnLink}
          className="w-fit"
          data-analytics-id="Home feed card"
          data-analytics-attributes={JSON.stringify({
            description: `${type} tile cta`
          })}
          data-qa={`${type} promo tile link`}
        >
          <PrimaryButton className="min-h-[40px] w-full m:w-[250px]">
            {btnText}
          </PrimaryButton>
        </a>
      </InnerWrapper>
    </PromoCard>
  );
}
